module.exports = __webpack_public_path__ + "static/deeksha-0ae129f65b985cf1aafc5875597159f7.jpeg";